import { render, staticRenderFns } from "./OcrPageView.vue?vue&type=template&id=7f670fce&scoped=true&"
import script from "./OcrPageView.vue?vue&type=script&lang=js&"
export * from "./OcrPageView.vue?vue&type=script&lang=js&"
import style0 from "./OcrPageView.vue?vue&type=style&index=0&id=7f670fce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f670fce",
  null
  
)

export default component.exports